module.exports = __webpack_public_path__ + "static/media/picture-(284).c0d1a91b.JPG";